import { ReactNode } from "react";
import { useElementSize } from "usehooks-ts";
import { LoadingOutlined } from "@ant-design/icons";

export function DynamicCanvas({
  children,
  loading,
}: {
  loading?: boolean;
  children(info: { width: number; height: number }): ReactNode;
}) {
  const [ref, { width, height }] = useElementSize();
  return (
    <div
      data-approle="dynamic-canvas"
      ref={ref}
      style={{
        height: "100%",
        width: "100%",
        position: "relative",
        overflow: "visible",
      }}
    >
      {loading ? (
        <div
          key="loading"
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            height,
            width,
            overflow: "visible",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 100,
          }}
        >
          <LoadingOutlined />
        </div>
      ) : (
        <div
          key="ready"
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            height,
            width,
            overflow: "visible",
          }}
        >
          {children({ width, height })}
        </div>
      )}
    </div>
  );
}
